import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard.component';
import { AuthGuard } from 'app/_guards';

const routes: Routes = [
    {
        path: '',
        canActivate: [AuthGuard],
        component: DashboardComponent,
        children: [
            {
                path: '',
                redirectTo: 'home',
                pathMatch: 'full'
            },
            {
                path: 'home',
                loadChildren: () => import('./home/home.module').then(mod => mod.HomeModule) 
            },
            {
                path: 'home-cb',
                loadChildren: () => import('./home-cb/home-cb.module').then(mod => mod.HomeCbModule) 
            },
            {
                path: 'calendar',
                loadChildren: () => import('./calendar/calendar.module').then(mod => mod.CalendarModule),
            },
            {
                path: 'activities',
                loadChildren: () => import('./activities/activities.module').then(mod => mod.ActivitiesModule),
            },
            {
                path: 'mail',
                loadChildren: () => import('./mail/mail.module').then(mod => mod.MailModule),
            },
            {
                path: 'reports',
                loadChildren: () => import('./reports/reports.module').then(mod => mod.ReportsModule),
            },
            {
                path: 'sequences',
                loadChildren: () => import('./sequences/sequences.module').then(mod => mod.SequencesModule),
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class DashboardRoutingModule { }
